// src/service/api.ts
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL?.trim()
  //   withCredentials: true,                    // envia cookies se usar HttpOnly
});

// Você pode adicionar interceptores globais aqui se não usar o AuthContext
export default api;
